import { HistoryEntity } from 'commons/types/DTO/bank/historyAudit'
import { DateTime, Link } from 'ui/components'
import { TableColumn } from 'ui/components/Table'

import { HistoryRecordDetails } from '../HistoryRecordDetails'

export const columns = (
  showTypeColumn: boolean,
  showEntityIdColumn: boolean,
  onClickEntityId?: (entityId: string) => void
): TableColumn<HistoryEntity>[] =>
  [
    {
      title: 'User',
      align: 'center',
      key: 'userInfo',
      width: '200px',
      render: ({ userInfo }) => (
        <div>
          {userInfo?.userEmail}
          <div>{userInfo?.userFullname}</div>
          <div>
            <i>{userInfo?.userTypeLabel}</i>
          </div>
        </div>
      )
    },
    {
      title: 'Date',
      align: 'center',
      width: '170px',
      key: 'date',
      render: ({ date }) => <DateTime withTime date={date} />
    },
    {
      title: 'Action',
      align: 'center',
      width: '100px',
      key: 'id',
      render: ({ actionLabel }) => <span data-qa="action-type-row">{actionLabel}</span>
    },
    showEntityIdColumn
      ? {
          title: 'Entity ID',
          align: 'left',
          width: '200px',
          key: 'entityId',
          render: ({ entityId }) => (
            <Link
              to="."
              onClick={() => {
                if (onClickEntityId) onClickEntityId(entityId)
              }}
            >
              {entityId}
            </Link>
          )
        }
      : null,
    showTypeColumn
      ? {
          title: 'Entity Type',
          align: 'center',
          width: '200px',
          key: 'entityTypeLabel',
          render: ({ entityTypeLabel }) => <span data-qa="entity-type-row">{entityTypeLabel}</span>
        }
      : null,
    {
      title: 'Details',
      sortable: false,
      key: 'id',
      render: ({ details, links }) => <HistoryRecordDetails links={links} changes={details} />
    }
  ].filter(Boolean) as TableColumn<HistoryEntity>[]
